// import React from 'react';
// import { Navigate } from 'react-router-dom';

// const ProtectedRoute = ({ children }) => {
//   const isAuthenticated = localStorage.getItem('token');
  
//   return isAuthenticated ? children : <Navigate to="/" />;
// };

// export default ProtectedRoute;

import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/" />; 
  }
 
  const tokenExpiration = JSON.parse(atob(token.split('.')[1])).exp * 1000;  
  const currentTime = Date.now();

  if (currentTime > tokenExpiration) { 
    alert("Your session has expired. Please log in again.");
    localStorage.removeItem("token");  
    return <Navigate to="/" />;
  }

  return children;  
};

export default ProtectedRoute;

